import { size, mediaQueries } from '@everlywell/leaves';
import styled from 'styled-components';
import { Section as RawSection } from './styles';

// Brand-centric Hero Styles
export const Section = styled(RawSection)`
  background-color: ${(props) => props.backgroundColor};
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${mediaQueries.forTabletHorizontalUp} {
    min-height: 350px;
    flex-direction: row;
  }
`;

export const TextContainer = styled.div`
  width: 100%;
  padding: ${size.md}px ${size.sm}px ${size.sm}px ${size.sm}px;
  margin: auto;
  z-index: 1;
  max-width: 515px;
  ${mediaQueries.forTabletHorizontalUp} {
    max-width: 536px;
    padding: ${size.sm}px;
  }
`;

export const MobileImg = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 200px;
  height: auto;
  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const ImageWrapper = styled.div`
  display: none;
  ${mediaQueries.forTabletHorizontalUp} {
    display: flex;
    align-self: stretch;
    max-width: 462px;
    width: 28%;
    height: 350px;
    overflow: visible;
  }

  .gatsby-image-wrapper {
    margin: 0 auto;
    display: block;
    align-self: flex-end;
    height: auto;
    max-height: 350px;
    overflow: hidden;
    min-height: 240px;
    left: 0;

    &.is-fixed-height {
      height: 100%;
    }

    &.is-left {
      left: -13px;
    }

    img {
      width: auto;
      margin: 0 auto;
    }
  }
`;
